import React from "react";
import ReportTypeScreen from "../../../Components/Reports/ReportTypeScreen";

function ReportedPostComments() {
  return <ReportTypeScreen reportType="post_comment" />;
}

export default ReportedPostComments;
